import apiFetch from "../../../api/apiFetch";

export const authService = {
  async signUp(registrationData: Record<string, any>) {
    const res = await apiFetch("/auth/register", {
      method: "POST",
      auth: false,
      body: JSON.stringify(registrationData),
    });
    // register wraps payload under `data`; login is flat — normalise here
    return res?.data ?? res;
  },

  async signIn(email: string, password: string) {
    return apiFetch("/auth/login", {
      method: "POST",
      auth: false,
      body: JSON.stringify({ email, password }),
    });
  },

  async signOut() {
    return apiFetch("/auth/logout", {
      method: "POST",
      auth: true,
    });
  },

  /** Revokes every device/session for this account, not just the current one. */
  async signOutAll() {
    return apiFetch("/auth/logout-all", {
      method: "POST",
      auth: true,
    });
  },

  async getCurrentUser() {
    return apiFetch("/auth/me", {
      method: "GET",
      auth: true,
    });
  },

  /** Lists this account's active sessions/devices. */
  async getSessions() {
    return apiFetch("/auth/sessions", {
      method: "GET",
      auth: true,
    });
  },

  async revokeSession(id: number) {
    return apiFetch(`/auth/sessions/${id}`, {
      method: "DELETE",
      auth: true,
    });
  },

  // ---------------- NOTIFICATIONS ----------------

  markAllNotificationsRead() {
    return apiFetch("/notifications/read-all", { method: "POST", auth: true });
  },

  // ---------------- ADMIN ----------------

  getDashboard() {
    return apiFetch("/admin/stats", {
      method: "GET",
      auth: true,
    });
  },

  // ---------------- ACCOUNT MANAGEMENT ----------------

  deleteAccount() {
    return apiFetch("/auth/delete-account", {
      method: "DELETE",
      auth: true,
    });
  },

  changePassword(data: {
    current_password: string;
    password: string;
    password_confirmation: string;
  }) {
    return apiFetch("/auth/change-password", {
      method: "POST",
      auth: true,
      body: JSON.stringify(data),
    });
  },
};
